// extracted by mini-css-extract-plugin
module.exports =  {"price":"a10a3f92e9--price--X1zFO"};